import React, { useEffect, useState, useRef } from 'react';
// import { NotificationManager } from 'react-notifications';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import {
  getNotifications,
  markNotificationsRead,
} from '../../actions/price_actions';
import { getSuggestions } from '../../actions/updatePrice';
import { getPriceCards } from '../../actions/dashboard';
import { bindActionCreators } from 'redux';
import './ui.css';

const showNotitification = (data) => {
  let {
    type,
    title,
    message,
    // markNotificationsRead,
    // id,
    // notificationData,
    // getPriceCards,
  } = data;
  let getToastContent = (message, title) => {
    return (
      <div>
        {title ? <h5>{title}</h5> : null}
        {message}
      </div>
    );
  };
  // let handleClose = () => {
  //   if (id !== 0 && notificationData) {
  //     markNotificationsRead([id]);
  //     if (notificationData.Type === 'freeze_price' && notificationData.isToday)
  //       getPriceCards();
  //   }
  // };
  switch (type) {
    // case 'info':
    //   toast.info(getToastContent(message, title), {
    //     position: toast.POSITION.TOP_RIGHT,
    //     onClose: handleClose,
    //   });
    //   break;
    case 'success':
      toast.success(getToastContent(message, title), {
        position: toast.POSITION.TOP_RIGHT,
      });
      break;
    case 'warning':
      toast.warning(getToastContent(message, title), {
        position: toast.POSITION.TOP_RIGHT,
      });
      break;
    case 'error':
      toast.error(getToastContent(message, title), {
        position: toast.POSITION.TOP_RIGHT,
      });
      break;
    default:
      break;
  }
};

function Notifications(props) {
  let {
    message,
    type,
    getNotifications,
    getSuggestions,
    lastId,
    title,
    authenticated,
    markNotificationsRead,
    id,
    notificationData,
    getPriceCards,
  } = props;
  const [newInfoCount, setNewInfoCount] = useState(0);
  const [bannerVisible, setBannerVisible] = useState(false);
  const autoDismissTimer = useRef(null);

  useEffect(() => {
    if (authenticated) {
      getNotifications(lastId);

      let interval = setInterval(
        (lastId) => {
          getNotifications(lastId);
        },
        30000,
        lastId
      );
      return () => clearInterval(interval);
    }
  }, [getNotifications, getSuggestions, lastId, authenticated]);

  useEffect(() => {
    if (type === 'info' && message) {
      setNewInfoCount((prev) => prev + 1);
      setBannerVisible(true);
      if (autoDismissTimer.current) clearTimeout(autoDismissTimer.current);
      autoDismissTimer.current = setTimeout(() => {
        setBannerVisible(false);
        setNewInfoCount(0);
      }, 8000);
    } else {
      showNotitification({
        type,
        title,
        id,
        message,
        markNotificationsRead,
        notificationData,
        getPriceCards,
      });
    }
  }, [
    type,
    title,
    id,
    message,
    markNotificationsRead,
    notificationData,
    getPriceCards,
  ]);

  const handleDismiss = () => {
    if (autoDismissTimer.current) clearTimeout(autoDismissTimer.current);
    if (id !== 0 && notificationData) {
      markNotificationsRead([id]);
      if (notificationData.Type === 'freeze_price' && notificationData.isToday)
        getPriceCards();
    }
    setBannerVisible(false);
    setNewInfoCount(0);
  };

  return (
    <>
      {bannerVisible && newInfoCount > 0 && (
        <div className="new-notifications-banner">
          <span className="new-notifications-banner__icon">🔔</span>
          <span className="new-notifications-banner__text">
            You have {newInfoCount} new notification{newInfoCount !== 1 ? 's' : ''}
          </span>
          <button
            className="new-notifications-banner__dismiss"
            onClick={handleDismiss}
            aria-label="Dismiss"
          >
            ✕
          </button>
        </div>
      )}
    </>
  );
}
const mapStateToProps = (state) => ({
  message: state.notification.message,
  title: state.notification.title,
  type: state.notification.type,
  id: state.notification.id,
  lastId: state.notification.lastId,
  authenticated: state.login.authenticated,
  notificationData: state.notification.notificationData,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getNotifications,
      markNotificationsRead,
      getPriceCards,
      getSuggestions,
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
